import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueFirestore from 'vue-firestore'
import debounce from 'debounce'
import vueHeadful from 'vue-headful'
import VueAnime from 'vue-animejs';

Vue.use(VueAnime)



import VueQRCodeComponent from 'vue-qrcode-component'
Vue.component('qr-code', VueQRCodeComponent)
Vue.use(VueFirestore);
Vue.use(debounce);

Vue.component('vue-headful', vueHeadful);


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
